import { Form, Formik } from "formik";
import { cumulativeValueTimeSeriesFieldEnum } from "kubb";
import * as Yup from "yup";
import NewTextFormComponent from "../../components/Forms/NewTextFormComponent";
import { yupRequiredString } from "../../components/Forms/yupValidators";
import { Button } from "../../components/Theme/button";
import CumulativeDataSelect from "./CumulativeDataSelect";
import type { TariffServiceDescription } from "./model";

export interface NewTariffServiceFormProps {
  create: (service: TariffServiceDescription) => Promise<any>;
}
function NewTariffServiceForm(props: NewTariffServiceFormProps) {
  return (
    <Formik
      initialValues={
        {
          service_name: "",
          consumption_type:
            cumulativeValueTimeSeriesFieldEnum["Energy (Heating)"],
        } as TariffServiceDescription
      }
      onSubmit={props.create}
      validationSchema={Yup.object().shape({
        service_name: yupRequiredString,
        consumption_type: yupRequiredString,
      })}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <NewTextFormComponent
            fieldName={"service_name"}
            label={{ label: "Service Name" }}
            disabled={isSubmitting}
          />
          <CumulativeDataSelect
            fieldName={"consumption_type"}
            label={{ label: "Consumption Type" }}
            disabled={isSubmitting}
          />
          <Button
            disabled={isSubmitting}
            onClick={submitForm}
            color={"brandLight"}
          >
            Add
          </Button>
        </Form>
      )}
    </Formik>
  );
}

export default NewTariffServiceForm;
